export interface ResetPasswordToken {
  userId: string;
  token: string;
  newPassword: string;
  confirmPassword: string;
}

export interface ForgotPassword {
  email: string;
}
